<template>
  <div class="box order-card-page order-detail-page caka-order-detail-page" :class="detailPageLayoutClass">
    <div v-if="showFixedOrderAddressHead" class="order-detail-address-fixed">
      <div class="order-detail-address-card">
        <order-head
          readonly
          :name="cakaData.consigneeName"
          :tel="cakaData.consigneePhone"
          :address="cakaData.consigneeAddress || ''"
        />
      </div>
    </div>
    <div class="order-detail-body-scroll" :class="{ 'has-fixed-pay-footer': Paystatus === '0' }">
    <div class="content-container">
      <!-- 按配送分组聚合：同组商品同一张卡片，底部统一展示配送/物流 -->
      <div v-for="(gBlock, gi) in displayProductGroups" :key="'pg-' + gi" class="order-card-wrap">
        <div class="bgc order-surface-card order-surface-card--tag">
          <div v-if="gBlock.items && gBlock.items.length" class="order-card-status-head">
            <div
              class="order-status-tag"
              :class="getStatusClass(groupHeadStatus(gBlock))"
            >{{ groupHeadStatusText(gBlock) }}</div>
          </div>
          <div
            v-for="(item, ii) in gBlock.items"
            :key="'pi-' + gi + '-' + ii"
            :class="['info-block', 'product-group-segment', { 'is-not-first-product': ii > 0 }]"
          >
              <div class="product-head">
                <img :src="item.url" alt="" class="img" />
                <div class="product-body">
                  <div class="product-main">
                    <span class="textTitle"> {{ item.productName }}</span>
                    <span class="textcontext product-spec"> {{ item.skuName }}</span>
                    <span class="textcontext product-taste" v-if="item.tastesName">口味：{{ item.tastesName }}</span>
                  </div>
                  <div class="product-price-col">
                    <div class="product-price-line" v-if="item.isShowPrice !== false">
                      <span class="product-amount">{{ formatDisplayNumber(item.showPrice) }}{{ getProductDisplayUnit() }}</span>
                      <span class="product-qty">x{{ item.emptionNum }}</span>
                    </div>
                    <div class="product-price-line" v-else>
                      <span class="product-amount">&nbsp;</span>
                      <span class="product-qty">x{{ item.emptionNum }}</span>
                    </div>
                    <div v-if="item.userRefundAmount" class="product-refund">
                      已退{{ formatDisplayNumber(item.userRefundAmount) }}{{ getProductDisplayUnit() }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.chargeDetails && item.chargeDetails.length" class="charge-list">
                <div class="charge-list-title">附件</div>
                <div class="charge-row" v-for="(c, ci) in item.chargeDetails" :key="ci">
                  <span class="charge-name">{{ c.chargeName }}</span>
                  <span class="charge-qty">×{{ c.quantity }}</span>
                  <span
                    v-if="item.isShowPrice !== false"
                    class="charge-amount"
                  >{{ formatChargeAmount(c.chargePrice) }}{{ getProductDisplayUnit() }}</span>
                </div>
                <div class="charge-row" v-if="item.isShowPrice !== false && item.chargeTotalAmount">
                  <span class="charge-name" style="color:#888;">附件小计</span>
                  <span class="charge-qty">&nbsp;</span>
                  <span class="charge-amount" style="font-weight:600;">
                    {{ formatChargeAmount(item.chargeTotalAmount) }}{{ getProductDisplayUnit() }}
                  </span>
                </div>
              </div>
              <div v-if="item.blessings" class="sendjcsb">
                <span style="color: #888;min-width: 4rem;">祝福语</span>
                <span>{{ item.blessings }}</span>
              </div>
              <div v-if="item.buyerMsg" class="sendjcsb">
                <span style="color: #888;min-width: 4rem;">备注</span>
                <span>{{ item.buyerMsg }}</span>
              </div>
              <div v-if="item.rechargeAccount" class="sendjcsb">
                <span style="color: #888;">充值账户</span>
                <span>{{ item.rechargeAccount }}</span>
              </div>
              <div v-if="item.productType === '9' || item.productType === '11'" class="action-row">
                <span class="action-row-label">订单详情</span>
                <div class="action-row-actions">
                  <div class="action-btn action-btn-secondary" @click.stop="goThirdPartyH5OrderDetail(item.orderNo, item.productType, item.id)">
                    查看
                  </div>
                </div>
              </div>
              <div v-if="item.cardPwd" class="info-block info-block--nested">
                <div @click="showcard(item.id)" class="expandable-header">
                  <span class="expand-title">卡号密码</span>
                  <div class="expand-indicator">
                    <span class="expand-text">{{ item.show ? '收起' : '展开' }}</span>
                    <van-icon :name="item.show ? 'arrow-up' : 'arrow-down'" size="0.8rem" color="#1890FF" />
                  </div>
                </div>
                <div v-if="item.show">
                  <div v-for="(item1, index) in item.cardPwd" :key="index" class="cardnp">
                    <div v-if="item1.cardNum" class="flex jcsb p-b-10">
                      <span>卡号：{{ item1.cardNum }}</span>
                      <span class="copy-btn" @click="copyText(item1.cardNum)"> 复制</span>
                    </div>
                    <div v-if="item1.cardPwd" class="flex jcsb p-b-10">
                      <span>密码：{{ item1.cardPwd }}</span>
                      <span class="copy-btn" @click="copyText(item1.cardPwd)"> 复制</span>
                    </div>
                    <div v-if="item1.exchangeUrl" class="p-b-10">
                      <span>兑换链接：</span>
                      <span class="inline-link-copy">
                        <span class="link-text">{{ item1.exchangeUrl }}</span>
                        <span class="copy-btn" @click="copyText(item1.exchangeUrl)">复制</span>
                      </span>
                    </div>
                    <div v-if="item1.exchangeWebsite" class="p-b-10">
                      <span>兑换说明：</span>
                      <span class="inline-link-copy">
                        <span class="link-text">{{ item1.exchangeWebsite }}</span>
                        <span class="copy-btn" @click="copyText(item1.exchangeWebsite)">复制</span>
                      </span>
                    </div>
                    <div v-if="item1?.expireDate" class="flex jcsb p-b-10">
                      <span>有效期：{{ $moment(item1?.expireDate).format("YYYY-MM-DD") }}</span>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <!-- 本组统一：配送方式、分组运费、物流（取组内首个可展示物流的子单） -->
          <div class="info-block group-delivery-block">
            <div v-if="groupShowsDeliveryMethodRow(gBlock)" class="sendjcsb">
              <span style="color: #888;">配送方式</span>
              <span>{{ getSendType(groupFooterItem(gBlock)) }}</span>
            </div>
            <div v-if="showGroupShipRow(gBlock.group)" class="sendjcsb">
              <span style="color: #888;">运费</span>
              <span class="group-ship-fee-value">
                <template v-if="gBlock.group.shipAmount > 0">
                  <span style="color:#D33B2E;">{{ formatDisplayNumber(gBlock.group.shipAmount) }}{{ getProductDisplayUnit() }}</span>
                </template>
                <template v-else>
                  <span style="color:#06A77D;">包邮</span>
                </template>
              </span>
            </div>
            <template v-if="showLogisticsInfo(groupLogisticsItem(gBlock))">
              <div v-if="(groupLogisticsItem(gBlock).shipType && groupLogisticsItem(gBlock).shipDate) || (groupLogisticsItem(gBlock).ship_type && groupLogisticsItem(gBlock).ship_date)" class="sendjcsb">
                <span style="color: #888;">{{ getSendType1(groupLogisticsItem(gBlock)) }}</span>
                <span>{{ getSendType2(groupLogisticsItem(gBlock)) }}</span>
              </div>
              <div v-if="groupLogisticsItem(gBlock).deliveryPerson" class="sendjcsb">
                <span style="color: #888;min-width: 5rem;">配送人员</span>
                <span>{{ groupLogisticsItem(gBlock).deliveryPerson }}</span>
              </div>
              <div v-if="groupLogisticsItem(gBlock).deliveryPersonPhone" class="sendjcsb">
                <span style="color: #888;min-width: 5rem;">配送电话</span>
                <a
                  class="delivery-tel-link"
                  :href="deliveryTelHref(groupLogisticsItem(gBlock).deliveryPersonPhone)"
                  @click.stop
                >{{ groupLogisticsItem(gBlock).deliveryPersonPhone }}</a>
              </div>
              <div v-if="ifShoow(groupLogisticsItem(gBlock))" class="sendjcsb">
                <span style="color: #888;min-width: 5rem;">门店名称</span>
                <span>{{ groupLogisticsItem(gBlock).shopName ? groupLogisticsItem(gBlock).shopName : groupLogisticsItem(gBlock).take_shop_name }}</span>
              </div>
              <div v-if="ifShoow(groupLogisticsItem(gBlock))" class="sendjcsb">
                <span style="color: #888;min-width: 5rem;">门店地址</span>
                <span>{{ groupLogisticsItem(gBlock).shopDetail ? groupLogisticsItem(gBlock).shopDetail : groupLogisticsItem(gBlock).addr }}</span>
              </div>
              <div v-if="groupLogisticsItem(gBlock).showExpress === 1" class="action-row">
                <span class="action-row-label">物流</span>
                <div class="action-row-actions">
                  <div class="action-btn action-btn-secondary" @click.stop="goLogistics(groupLogisticsItem(gBlock))">
                    物流信息
                  </div>
                  <div v-if="groupLogisticsItem(gBlock).status == '10'" class="action-btn action-btn-primary" @click.stop="sureget(groupLogisticsItem(gBlock).id)">
                    确认收货
                  </div>
                </div>
              </div>
            </template>
            <div v-if="isDsMealGroup(gBlock)" class="action-row">
              <span class="action-row-label">订单详情</span>
              <div class="action-row-actions">
                <div
                  class="action-btn action-btn-secondary"
                  @click.stop="goThirdPartyH5OrderDetail(groupFooterItem(gBlock).orderNo, '12', groupFooterItem(gBlock).id)"
                >
                  查看
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 取餐信息：订单级，只展示一次 -->
      <div v-if="cakaData?.takeMealCode" class="order-card-wrap">
        <div class="bgc order-surface-card">
          <div class="info-block">
            <div @click="showInter()" class="expandable-header">
              <span class="expand-title">取餐信息</span>
              <div class="expand-indicator">
                <span class="expand-text">{{ showInters ? '收起' : '展开' }}</span>
                <van-icon :name="showInters ? 'arrow-up' : 'arrow-down'" size="0.8rem" color="#1890FF" />
              </div>
            </div>
            <div v-if="showInters" class="cardnp">
              <div v-if="cakaData.consigneePhone" class="flex jcsb p-b-10">
                <span>取餐手机号：</span>
                <span>{{ cakaData.consigneePhone }}</span>
              </div>
              <div v-if="cakaData.takeMealCode" class="flex jcsb p-b-10">
                <span>取餐码：</span>
                <span>
                  <ul style="margin:0;padding:0;list-style:none;">
                    <li v-for="tm in takeMealCodeArr" :key="tm">{{ tm }}</li>
                  </ul>
                </span>
              </div>
              <div v-if="cakaData.shipTimeText" class="flex jcsb p-b-10">
                <span>出餐时间：</span>
                <span class="ellipsis">{{ cakaData.shipTimeText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 订单信息块 -->
      <div class="bgc order-surface-card order-meta-card">
        <div class="info-block">
          <div style="font-size: 1rem;font-weight: 600;">订单信息</div>
        </div>
        <div class="info-block">
          <div class="sendjcsb">
            <span style="color: #888;">订单编号</span>
            <div class="order-number-section">
              <span>{{ orderNo }}</span>
              <span class="copy-btn" @click="copyText(orderNo)">复制</span>
            </div>
          </div>
          <div class="sendjcsb">
            <span style="color: #888;">下单时间</span>
            <span>{{ cakaData?.createAt }}</span>
          </div>
          <div v-if="cakaData?.consumptionType" @click="showPayDetail" class="expandable-row">
            <span class="row-label">支付方式</span>
            <div class="expand-indicator">
              <span class="row-value">{{ getPayType() }}</span>
              <span class="expand-text">查看</span>
              <van-icon name="arrow" size="0.8rem" color="#1890FF" />
            </div>
          </div>
          <div v-if="cakaData?.orderPrice" class="sendjcsb">
            <span style="color: #888;">订单金额</span>
            <span>{{ cakaData?.orderPrice }}{{ cakaData?.cardPointTypeUnit || '点' }}</span>
          </div>
          <div v-if="cakaData?.serviceFeeAmount" class="sendjcsb">
            <span style="color: #888;">服务费</span>
            <span>{{ cakaData?.serviceFeeAmount }}{{ cakaData?.cardPointTypeUnit || '点' }}</span>
          </div>
          <div v-if="cakaData?.postMoney" class="sendjcsb">
            <span style="color: #888;">{{ orderShipFeeRowLabel }}</span>
            <span>{{ formatDisplayNumber(cakaData?.postMoney) }}{{ getProductDisplayUnit() }}</span>
          </div>
          <div v-if="Paystatus !== '4' && Paystatus !== '5'" class="sendjcsb">
            <span v-if="Paystatus == '0'" style="color: #888;">需付款</span>
            <span v-else style="color: #888;">实付款</span>
            <div>
              <div class="price">
                <div v-if="cakaData?.originalPrice" style="text-align: end;">
                  <span style="font-size: 0.95rem;font-weight: 600;">{{ cakaData?.payProductTotal }}</span>
                  <span style="font-size: 0.8rem;">{{ cakaData?.cardPointTypeUnit || '点' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="cakaData?.userRefundAmount" class="sendjcsb">
            <span style="color: #888;">退款点数</span>
            <span>{{ cakaData?.userRefundAmount }}{{ cakaData?.cardPointTypeUnit || '点' }}</span>
          </div>
          <div v-if="cakaData?.refundStatus" class="sendjcsb">
            <span style="color: #888;">退款状态</span>
            <span>{{ cakaData?.refundStatus }}</span>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div v-if="Paystatus === '0'" class="bottom">
      <div class="price">
        <span style="font-size: 0.85rem;margin-top: 0.1rem;font-weight: 500;color: #D23B2E;">需支付：{{ cakaData?.payProductTotal }}{{ cakaData?.cardPointTypeUnit || '点' }}</span>
      </div>
      <div class="flex">
        <div class="action-btn action-btn-secondary" @click.stop="showDialog">
          取消订单
        </div>
        <div class="action-btn action-btn-primary" @click.stop="changePay">
          去支付
        </div>
      </div>
    </div>


    <Translate ref="translate" v-if="showWL" :logistic-code="LogisticCode" :shipper-name="ShipperName"
      :data-list="logisticsInfo" :logistics-list="logisticsList" :order-no="orderNo" @closed="closedadd" @SelectTab="getLogistics"
      :active="0">
    </Translate>
    <PayList v-if="showPL" :pay-list="payList" @closed="closedPay">
    </PayList>
  </div>
</template>

<script>

import Translate from "../../components/order/Translate.vue";
import PayList from "../../components/order/PayList.vue";
import OrderHead from "../../components/order/OrderHead.vue";
import { isUnifiedOrderPaid, startUnifiedPayStatusPoll } from "@/utils/orderPayPoll";

export default {
  name: "",

  data() {
    return {

      phone: '',
      cakaData: null,
      Paystatus: '',
      userId: '',
      pic: '',
      weiPrice: null,
      orderNo: '',
      selectIndex: 0,
      showWL: false,
      logisticsList: [],
      showAll: false,
      LogisticCode: '',
      ShipperName: '',
      showPL: false,
      payList: [],
      logisticsInfo: [],
      showInters: false,
      browserBackGuardEnabled: false,
      stopPayConfirmPoll: null,
    };
  },
  components: { Translate, PayList, OrderHead },
  computed: {
    takeMealCodeArr() {
      if (!this.cakaData?.takeMealCode) return [];
      return this.cakaData.takeMealCode.split(',');
    },
    // groupId → group 反查表（订单详情页"配送分组"行使用）
    groupIdMap() {
      const map = {};
      (this.cakaData?.groups || []).forEach(g => {
        if (g && g.id != null) map[g.id] = g;
      });
      return map;
    },
    groupSeqMap() {
      const map = {};
      (this.cakaData?.groups || []).forEach(g => {
        if (g && g.groupSeq != null) map[g.groupSeq] = g;
      });
      return map;
    },
    /**
     * 按 groups.groupSeq 决定分组卡片顺序；无 groups 时退化为「一子单一卡片」。
     * 组内商品顺序与 productSubOrderList 一致。
     * 未匹配到 groups 中任一条的子单：一子单一卡（不按 groupSeq 合并）。
     */
    displayProductGroups() {
      const list = this.cakaData?.productSubOrderList;
      if (!list || !list.length) return [];
      const groups = this.cakaData?.groups || [];
      if (!groups.length) {
        return list.map(item => ({ group: null, items: [item] }));
      }
      const sorted = [...groups].sort(
        (a, b) => (Number(a.groupSeq) || 0) - (Number(b.groupSeq) || 0)
      );
      const used = new Array(list.length).fill(false);
      const out = [];
      sorted.forEach(g => {
        const items = [];
        list.forEach((it, idx) => {
          if (used[idx]) return;
          const byId = g.id != null && it.groupId != null && String(it.groupId) === String(g.id);
          const bySeq = it.groupSeq != null && g.groupSeq != null && String(it.groupSeq) === String(g.groupSeq);
          if (byId || bySeq) {
            items.push(it);
            used[idx] = true;
          }
        });
        if (items.length) out.push({ group: g, items });
      });
      const unmatched = [];
      list.forEach((it, idx) => {
        if (!used[idx]) unmatched.push(it);
      });
      return out.concat(unmatched.map(item => ({ group: null, items: [item] })));
    },
    /** 多批发货（多 group）时，底部 postMoney 一般为各批运费之和 */
    hasMultipleShipGroups() {
      return (this.cakaData?.groups || []).length > 1;
    },
    /** 订单信息区运费行：多批时强调「合计」，与每张商品卡上的「运费」区分 */
    orderShipFeeRowLabel() {
      return this.hasMultipleShipGroups ? '运费合计' : '快递费';
    },
    /** 主订单 consigneeAddress（含省市区+详细），子单不再带地址 */
    hasMainOrderDeliveryAddress() {
      const addr = this.cakaData?.consigneeAddress;
      if (addr === null || addr === undefined) return false;
      const s = String(addr).trim();
      if (!s) return false;
      const lower = s.toLowerCase();
      return lower !== 'null' && lower !== 'undefined';
    },
    /** 需配送且非门店自提：顶部固定地址栏（与结算页同布局，只读），数据仅主订单 */
    showFixedOrderAddressHead() {
      if (!this.cakaData || !this.hasMainOrderDeliveryAddress) return false;
      const list = this.cakaData.productSubOrderList || [];
      return list.some((it) => this.showLogisticsInfo(it) && !this.ifShoow(it));
    },
    detailPageLayoutClass() {
      return {
        'has-fixed-address': this.showFixedOrderAddressHead,
        'has-fixed-pay-footer': this.Paystatus === '0',
      };
    },
  },
  methods: {
    // 根据子单 groupId 取得所属 group（无分组数据时返回 null，自动隐藏分组行）
    getSubOrderGroup(item) {
      if (!item || item.groupId == null) return null;
      return this.groupIdMap[item.groupId] || null;
    },
    /** 组内用于配送方式/物流展示的参照子单（首个可展示物流的，否则第一个） */
    groupLogisticsItem(gBlock) {
      const items = (gBlock && gBlock.items) || [];
      if (!items.length) return {};
      const ok = items.find(i => this.showLogisticsInfo(i));
      return ok || items[0];
    },
    groupFooterItem(gBlock) {
      const items = (gBlock && gBlock.items) || [];
      return items[0] || {};
    },
    /** 组头：蛋叔点餐忽略已退款行，与主单汇总一致；其它类型仍是不一致则部分出餐 */
    groupHeadStatus(gBlock) {
      const items = (gBlock && gBlock.items) || [];
      if (!items.length) return '';
      if (this.isDsMealGroup(gBlock)) {
        return this.resolveDsMealHeadStatus(items);
      }
      const first = items[0].status;
      if (items.some(i => i.status !== first)) return '20';
      return first;
    },
    groupHeadStatusText(gBlock) {
      const items = (gBlock && gBlock.items) || [];
      if (!items.length) return '';
      const status = this.groupHeadStatus(gBlock);
      const hit = items.find(i => i.status === status);
      if (hit && hit.statusT) return hit.statusT;
      if (status === '20') return '部分出餐';
      if (status === '25') return '已退款';
      if (status === '16') return '待出餐';
      if (status === '17') return '已出餐';
      return items[0].statusT;
    },
    /** 已退款行不参与：剩余全 16→待出餐，全 17→已出餐，混→部分出餐，全退→已退款 */
    resolveDsMealHeadStatus(items) {
      const alive = items.filter(i => String(i.status) !== '25');
      if (!alive.length) return '25';
      const any16 = alive.some(i => i.status === '16');
      const any17 = alive.some(i => i.status === '17');
      const any20 = alive.some(i => i.status === '20');
      const any18 = alive.some(i => i.status === '18');
      if (any20 || (any16 && (any17 || any18)) || (any17 && any18)) return '20';
      if (any17) return '17';
      if (any18) return '18';
      return '16';
    },
    isDsMealGroup(gBlock) {
      return ((gBlock && gBlock.items) || []).some((it) => it.productType === '12');
    },
    /** 与原先单条一致：productType 为 9 时不展示「配送方式」行 */
    groupShowsDeliveryMethodRow(gBlock) {
      return (gBlock.items || []).some(it => it.productType != '9');
    },
    /** 多批订单时展示每张卡上的「运费」（金额或包邮） */
    showGroupShipRow(group) {
      return !!(group && (this.cakaData?.groups || []).length > 1);
    },
    enableBrowserBackGuard() {
      if (this.browserBackGuardEnabled) return;
      // 追加一层当前详情页历史，拦截微信浏览器底部返回时回到收银台的问题。
      window.history.pushState({ fromUnifiedCashierGuard: true }, '', window.location.href);
      window.addEventListener('popstate', this.handleBrowserBackGuard);
      this.browserBackGuardEnabled = true;
    },
    handleBrowserBackGuard() {
      // 仅对“支付成功后从统一收银台进入详情”的场景生效，统一改回订单列表。
      this.$router.replace({ path: '/AllOrder', query: { active: 1 } });
    },
    disableBrowserBackGuard() {
      if (!this.browserBackGuardEnabled) return;
      window.removeEventListener('popstate', this.handleBrowserBackGuard);
      this.browserBackGuardEnabled = false;
    },
    getStatusClass(status) {
      if (status == '0') return 'status-payment'
      return 'status-other'
    },
    copyText(text) {
      // 统一复制功能实现
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$Toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy(text) {
      // 兼容性复制方法
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$Toast('复制成功');
      } catch (err) {
        this.$Toast('复制失败');
      }
      document.body.removeChild(textArea);
    },
    showPayDetail() {
      if (this.payList && this.payList.length > 0) {
        this.showPL = true
      }
    },
    showInter() {
      if (this.showInters) {
        this.showInters = false
      } else
        this.showInters = true
    },
    showcard(id) {
      this.cakaData.productSubOrderList.forEach((item, index) => {
        if (item.id == id) {
          if (item.show) {
            item.show = false
          } else {
            item.show = true
          }
          this.$set(this.cakaData.productSubOrderList, index, item);
        }
      });
    },
    sureget(val) {
      this.$api
        .confirmReceipt(this.orderNo, val)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else {
            this.$Toast(res.msg);
            this.getOrderzyDetail()
          }
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    closedadd(val) {
      this.showWL = val
    },
    closedPay(val) {
      this.showPL = val
    },
    formatDisplayNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '0'
      }
      const numberValue = Number(value)
      if (Number.isNaN(numberValue)) {
        return value
      }
      return numberValue.toString()
    },
    getProductDisplayUnit() {
      // 商品展示区只在次卡/金豆卡订单时沿用订单单位，其他卡型统一按点展示。
      if (this.cakaData?.cardPointType === '3' || this.cakaData?.cardPointType === '4') {
        return this.cakaData?.cardPointTypeUnit || '点'
      }
      return '点'
    },
    getPayType() {
      if (this.cakaData?.consumptionType == '0') {
        return '卡余额支付'
      } else if (this.cakaData?.consumptionType == '1') {
        return '在线支付'
      } else if (this.cakaData?.consumptionType == '2') {
        return '卡余额支付+微信支付'
      }
    },
    getSendType(val) {
      if (val?.shipType) {
        if (val?.shipType == 'delivery') {
          return '商家配送'
        } else if (val?.shipType == 'shop') {
          return '门店自提'
        } else if (val?.shipType == 'same') {
          return '快递配送'
        } else if (val?.shipType == 'logistic') {
          return '无需物流'
        }
      } else {
        if (val?.ship_type == 'delivery') {
          return '商家配送'
        } else if (val?.ship_type == 'shop') {
          return '门店自提'
        } else if (val?.ship_type == 'same') {
          return '快递配送'
        } else if (val?.ship_type == 'logistic') {
          return '无需物流'
        }
      }
    },
    ifShoow(val) {
      if (val.shipType && val.shipType == 'shop') {
        return true
      } else if (val.ship_type && val.ship_type == 'shop') {
        return true
      } else {
        return false
      }
    },
    // 展示物流信息
    showLogisticsInfo(val) {
      // 无需物流 不展示 物流相关内容
      if ((val.shipType && val.shipType == 'logistic') || val.ship_type && val.ship_type == 'logistic' ){
        return false
      } else {
        return true
      }
    },

    getSendType1(val) {
      if (val?.shipType && val.shipDate) {
        if (val?.shipType == 'delivery') {
          return '配送时间'
        } else if (val.shipType == 'shop') {
          return '自提时间'
        } else {
          return '配送时间'
        }
      } else if (val?.ship_type && val.ship_date) {
        if (val?.ship_type == 'delivery') {
          return '配送时间'
        } else if (val?.ship_type == 'shop') {
          return '自提时间'
        } else {
          return '配送时间'
        }
      }
    },
    getSendType2(val) {
      if (val?.shipType && val?.shipDate) {
        return val?.shipDate + ' ' + val?.shipTimeText
      } else if (val?.ship_type && val?.ship_date) {
        return this.$moment(val?.ship_date).format("MM月DD日") + ' ' + val?.ship_time_text
      }
    },
    goLogistics(val) {
      this.logisticsInfo = val.logisticsInfo
      this.getLogistics(this.logisticsInfo[0], val.orderNo)
    },
    getLogistics(val, orderNo) {
      let form = {
        logisticCode: val?.logisticCode,
        shipperCode: val?.shipperCode,
        customerName: val?.customerName,
        orderCode: orderNo,
      }
      this.$api
        .queryEbusiness(form)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else {
            this.LogisticCode = res.data.LogisticCode
            this.ShipperName = res.data.ShipperName
            this.logisticsList = res.data.Traces
            this.showWL = true
          }

        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    toPay() {
      // 统一跳转到统一支付页面，只需传订单号
      this.$router.push({
        path: "/UnifiedCashier",
        query: {
          orderNo: this.orderNo,
        },
      });
    },
    showDialog() {
      this.$Dialog.confirm({
        title: "提示",
        message: "是否确认取消订单？",
        confirmButtonText: '我在想想',
        cancelButtonText: '取消订单'
      })
        .then(() => {
        })
        .catch(() => {
          // on cancel
          this.cancelPayment()
        });
    },
    cancelPayment() {
      this.$api
        .productcancelPayment(this.orderNo)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else {
            this.$Toast(res.msg);
            this.$router.back();
          }
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    getPrice(num, price) {
      return parseFloat(num) * parseFloat(price).toFixed(2)
    },
    /**
     * 蛋叔 V2 附件金额格式化（保留两位小数,与 showPrice 同单位）
     */
    formatChargeAmount(amount) {
      const num = Number(amount || 0)
      return Math.round(num * 100) / 100
    },
    changePay() {
      this.toPay()
    },
    getTotlePrice() {
      let totlePrce = 0
      this.cakaData?.productSubOrderList.forEach(element => {
        totlePrce += this.getPrice(element.emptionNum, element.showPrice)
      });
      return totlePrce
    },
    getOrderzyDetail() {
      return this.$api
        .queryOrderInfoDetail(this.orderNo)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else if (res.data) {
            this.cakaData = res.data;
            this.payList = this.cakaData.spendLogList;
            this.weiPrice = this.cakaData.extraPay;
            this.Paystatus = this.cakaData.status;
          }
          return this.Paystatus;
        })
        .catch(() => {
          return this.Paystatus;
        });
    },
    stopUnifiedCashierPayPoll() {
      if (typeof this.stopPayConfirmPoll === "function") {
        this.stopPayConfirmPoll();
        this.stopPayConfirmPoll = null;
      }
    },
    startUnifiedCashierPayPollIfNeeded() {
      if (this.$route.query.fromUnifiedCashier !== "1") {
        return;
      }
      if (isUnifiedOrderPaid(this.Paystatus)) {
        return;
      }
      this.stopUnifiedCashierPayPoll();
      this.stopPayConfirmPoll = startUnifiedPayStatusPoll({
        fetchStatus: () => this.getOrderzyDetail(),
      });
    },
    changeItem(index) {
      this.selectIndex = index
    },
    getPhone(val) {
      if (val) {
        return this.$utils.formPhone(val);
      }
    },
    /** 配送电话拨号：仅数字写入 tel:，避免空格、横线导致无法唤起拨号 */
    deliveryTelHref(phone) {
      if (!phone) return '#'
      const digits = String(phone).replace(/\D/g, '')
      return digits ? `tel:${digits}` : '#'
    },
    // 跳转三方订单详情
    goThirdPartyH5OrderDetail(orderNo, productType, orderSortId) {
      // 三方订单特殊处理
      if(productType == '9'){
        this.$api
          .goToMtH5OrderDetail(orderNo)
          .then((res) => {
            if (res.code === 0) {
              window.location.href = res.data;
            } else {
              this.$Toast.fail(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$Toast.fail('跳转失败');
          });
      }else if(productType == '11'){
        this.$api
          .goToTfkH5OrderDetail(orderNo, orderSortId)
          .then((res) => {
            if (res.code === 0) {
              window.location.href = res.data;
            } else {
              this.$Toast.fail(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$Toast.fail('跳转失败');
          });
      }else if(productType == '12'){
        this.$api
          .goToDsH5OrderDetail(orderNo)
          .then((res) => {
            if (res.code === 0) {
              window.location.href = res.data;
            } else {
              this.$Toast.fail(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$Toast.fail('跳转失败');
          });
      }
    },
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id
    this.phone = localStorage.getItem("loginphone")
    this.getOrderzyDetail().finally(() => {
      this.startUnifiedCashierPayPollIfNeeded();
    });
    if (this.$route.query.fromUnifiedCashier === '1') {
      this.enableBrowserBackGuard()
    }
    // 进入页面自动滚动到顶部
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    this.stopUnifiedCashierPayPoll();
    this.disableBrowserBackGuard();
  },
  watch: {},
};
</script>

<style lang='scss' scoped>
@import "@/styles/order-card.scss";

.box {
  background-color: #f8f8f8;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 与结算页：顶栏固定不随列表滚动 */
.caka-order-detail-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.order-detail-address-fixed {
  flex: 0 0 auto;
  padding-top: var(--order-page-top-gap, 0.4rem);
}

.order-detail-address-card {
  margin: 0 var(--order-h-margin, 0.8rem);
  background: #fff;
  border-radius: var(--order-card-radius, 0.8rem);
  box-shadow: var(--order-card-shadow, 0 2px 8px rgba(0, 0, 0, 0.05));
  overflow: hidden;
}

.order-detail-address-card :deep(.order-head) {
  --order-head-edge-gap: 0.45rem;
}

.order-detail-body-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0;
  padding-top: var(--order-page-top-gap, 0.4rem);
  padding-bottom: 1rem;
}

/* 有地址栏时：顶距由地址区承担，列表与地址区间距=卡片间距（与结算页一致） */
.caka-order-detail-page.has-fixed-address .order-detail-body-scroll {
  padding-top: 0;
  margin-top: var(--order-block-gap, 0.55rem);
}

.order-detail-body-scroll.has-fixed-pay-footer {
  padding-bottom: calc(4.5rem + env(safe-area-inset-bottom, 0px));
}

.content-container {
  /* 滚动由 .order-detail-body-scroll 承担 */
  min-height: 0;
  overflow: visible;

  .price {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    color: #D23B2E;
    font-size: 1.1rem;
    min-width: 0;
    overflow: hidden;
  }
  
  .priceB {
    min-width: 3.5em;
    display: flex;
    margin-left: 1rem;
    flex-direction: row;
    justify-content: end;
    color: #D23B2E;
    font-size: 0.9rem;
  }
  
  .textTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 500;
    font-size: 1rem;
    color: #333;
    line-height: 1.35;
    margin-bottom: 0.35rem;
  }

  .textcontext {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 0.35rem;
    line-height: 1.35;
  }

  .product-spec {
    color: #555;
  }

  .product-taste {
    color: #666;
  }

  .product-main {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  .product-price-col {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: auto;
    padding-bottom: 0.12rem;
  }

  .product-price-line {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-end;
    width: 100%;
    gap: 0.1rem;
    white-space: nowrap;
  }

  .product-amount {
    font-size: 1.14rem;
    font-weight: 600;
    color: #d33b2e;
    line-height: 1.2;
  }

  .product-qty {
    font-size: 0.82rem;
    font-weight: 500;
    color: #888;
    margin-left: 0.2rem;
  }

  .product-refund {
    font-size: 0.75rem;
    color: #888;
    text-align: right;
    margin-top: 0.12rem;
  }

  .order-status-tag {
    transition: all 0.3s ease;
  }

  .product-group-segment.is-not-first-product {
    border-top: 1px solid #f0f0f0;
    margin-top: 0.55rem;
    padding-top: 0.65rem;
  }

  .group-delivery-block {
    border-top: 1px solid #f0f0f0;
    margin-top: 0.55rem;
    padding-top: 0.65rem;
  }

  .group-ship-fee-value {
    text-align: right;
    flex: 1;
    min-width: 0;
  }

  .info-block--nested {
    margin-top: 0.5rem;
  }

  /* 待支付 - 红色渐变 */
  .order-status-tag.status-payment {
      background: linear-gradient(135deg, #FF6B6B 0%, #D23B2E 100%);
      color: white;
      box-shadow: 0 4px 12px rgba(210, 59, 46, 0.3);
  }

  /* 其他状态 - 蓝色渐变 */
  .order-status-tag.status-other {
      background: linear-gradient(135deg, #4DABF7 0%, #1890FF 100%);
      color: white;
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  }

  .msg {
    margin-top: 1.2rem;
    padding-top: 0.8rem;
    border-top: 1px solid #f0f0f0;
  }
}

.sendjcsb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #666;
  padding: 0.4rem 0;
}

/* 蛋叔 V2 附件明细 */
.charge-list {
  border-top: 1px dashed #ededed;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
}

.charge-list-title {
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 0.3rem;
}

.charge-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #333;
  padding: 0.2rem 0;
}

.charge-row .charge-name {
  flex: 1;
  min-width: 0;
}

.charge-row .charge-qty {
  margin: 0 0.5rem;
  color: #888;
}

.charge-row .charge-amount {
  color: #D23B2E;
}

.action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  font-size: 0.85rem;
}

.action-row-label {
  color: #888;
  min-width: 5rem;
  flex-shrink: 0;
}

.action-row-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
  flex: 1 1 auto;
  min-width: 0;
}

.cardnp {
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-radius: 0.8rem;
  padding: 0.8rem;
  font-size: 0.9rem;
  margin-top: 0.6rem;
  color: #666;
  line-height: 1.5;

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.18rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .p-b-10 {
    padding-bottom: 0.18rem !important;
  }
}

.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-top: 1px solid #ededed;
  padding: 0.6rem 1rem;
  padding-bottom: calc(0.6rem + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
  overflow: hidden;
  box-sizing: border-box;
}

.info-block + .info-block {
  margin-top: 0.6rem;
  padding-top: 0.6rem;
}

.inline-link-copy {
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
  vertical-align: middle;
  max-width: 100%;
}
.inline-link-copy .link-text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  text-align: left;
}

.clickable-title {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  line-height: 1.5rem;
  font-weight: 600;
  color: #D23B2E;
  font-size: 1rem;
  cursor: pointer;
  user-select: none;
  border-radius: 0.5rem;
  background: #f9f3f1;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 4px rgba(210,59,46,0.04);
}
.clickable-title:active {
  background: #f1e6e3;
  color: #D23B2E;
  box-shadow: 0 2px 8px rgba(210,59,46,0.08);
}

/* 新的展开样式 */
.expandable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.8rem 0.5rem;
  transition: all 0.3s ease;
  border-radius: 0.5rem;
  margin: 0 -0.5rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.expandable-header:hover {
  background-color: #e9ecef;
  border-color: #1890FF;
}

.expandable-header:active {
  background-color: #dee2e6;
  transform: scale(0.98);
}

.expand-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.expand-indicator {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.expand-text {
  font-size: 0.8rem;
  color: #1890FF;
  font-weight: 500;
}

/* 展开行样式 */
.expandable-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 0.4rem 0.5rem;
  margin: 0 -0.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.expandable-row:hover {
  background-color: #f8f9fa;
}

.expandable-row:active {
  background-color: #e9ecef;
  transform: scale(0.98);
}

.row-label {
  color: #888;
}

.row-value {
  color: #333;
  margin-right: 0.3rem;
}

.order-number-section {
  display: flex;
  align-items: center;
}

/* ========== 统一复制按钮样式 ========== */
.copy-btn {
  margin-left: 0.5rem;
  padding: 0.1rem 0.4rem;
  background: rgba(102, 102, 102, 0.1);
  color: #666;
  font-size: 0.75rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(102, 102, 102, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.copy-btn:active {
  background: rgba(102, 102, 102, 0.2) !important;
  transform: scale(0.95) !important;
}

/* 特殊布局中的复制按钮 */
.inline-link-copy .copy-btn {
  margin-left: 0.5rem;
}
/* ========== 复制按钮样式结束 ========== */

/* ========== 统一操作按钮样式 ========== */
.action-btn {
  display: inline-block;
  padding: 0;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 1.8rem;
  line-height: 1.8rem;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-width: 0.5px;
  border-style: solid;
  flex-shrink: 0;
  min-width: 4rem;
  max-width: calc(45% - 0.3rem);
  vertical-align: middle;
  text-align: center;
}

.action-btn + .action-btn {
  margin-left: 0.5rem;
}

.bottom .flex {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.5rem;
}

.sendjcsb .flex {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.action-btn-primary {
  background-image: linear-gradient(left, #ffcf7a 0%, #ffa976 100%);
  color: #f5f5f5;
  border-color: rgba(255, 207, 122, 0.3);
}

.action-btn-primary:active {
  background-image: linear-gradient(left, #f5c470 0%, #f59e6c 100%);
  transform: scale(0.98) !important;
}

.action-btn-secondary {
  background: rgba(102, 102, 102, 0.05);
  color: #666666;
  border-color: rgba(102, 102, 102, 0.3);
}

.action-btn-secondary:active {
  background: rgba(102, 102, 102, 0.12) !important;
  transform: scale(0.98) !important;
}
/* ========== 操作按钮样式结束 ========== */

.delivery-tel-link {
  color: #1989fa;
  text-decoration: none;
  text-align: end;
  word-break: break-all;
  -webkit-tap-highlight-color: rgba(25, 137, 250, 0.15);
}
.delivery-tel-link:active {
  opacity: 0.75;
}
</style>